<template>
  <div class="page-layout__row  row">
    <div class="col-md-7 ml-3">
      <div class="page-layout__group-2 ">
        <table class="table-doc">
          <tbody v-if="application.typeId === APP_TYPE_EKYZMAT && application.resource">
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('title') }}:</th>
            <td class="table-doc__cell">
              {{ application.resource.positionName }}
            </td>
          </tr>
          <tr v-if="application.resource.resourceType.id === RESOURCE_EKYZMAT_ID">
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('department') }}:</th>
            <td class="table-doc__cell">
              <span v-if="application.resource.department">{{ application.resource.department.name }}</span>
            </td>
          </tr>
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('state') }}:</th>
            <td class="table-doc__cell">

                                <span v-if="application.resource.resourceType.id === RESOURCE_LOCAL_POSITIONS_ID">
                                    {{ application.resource.stateName }}
                                </span>
              <span v-else>
                                    <span v-if="application.resource.department && application.resource.department.state">
                                        {{ application.resource.department.state.name }}
                                    <span v-if="application.resource.department.state.stateParentName">,{{ application.resource.department.state.stateParentName }}</span>
                                    </span>
                                </span>
            </td>
          </tr>
          <tr v-if="POSITION_RESOURCES.indexOf(application.resource.resourceType.id) > -1">
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('serviceType') }}:</th>
            <td class="table-doc__cell">
              <span v-if="application.resource.postType"> {{ application.resource.postType.title }}</span>
              <span v-else-if="application.resource.type"> {{ application.resource.type.title }}</span>
            </td>
          </tr>
          <tr v-if="POSITION_RESOURCES.indexOf(application.resource.resourceType.id) > -1">
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('positionType') }}:</th>
            <td class="table-doc__cell">
                             <span v-if="application.resource.jobPost && application.resource.jobPost.type">
                                {{ application.resource.jobPost.type.title }}
                             </span>
              <span v-if="application.resource.registerPostType">
                                {{ application.resource.registerPostType.title }}
                             </span>
            </td>
          </tr>
          <tr v-if="application.resource.resourceType.id===RESOURCE_EKYZMAT_ID && application.resource.jobPost && application.resource.jobPost.category">
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('positionCategory') }}:</th>
            <td class="table-doc__cell">
              {{ application.resource.jobPost.category.title }}
            </td>
          </tr>
          <tr v-if="application.resource.resourceType.id===RESOURCE_EKYZMAT_ID && application.resource.jobPost">
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('registerPosition') }}:</th>
            <td class="table-doc__cell">
              {{ application.resource.jobPost.name }}
            </td>
          </tr>
          </tbody>
          <tbody v-else-if="application.resource">
          <tr v-if="application.resource.stateName" >
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('state') }}:</th>
            <td class="table-doc__cell">
              {{ application.resource.stateName }}
            </td>
          </tr>
          <tr v-if="application.resource.resourceTitle" >
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('title') }}:</th>
            <td class="table-doc__cell">
              {{ application.resource.resourceTitle }}
            </td>
          </tr>
          <tr v-if="application.resource.postScopeText">
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('postScope') }}:</th>
            <td class="table-doc__cell">
              {{ getTranslation(application.resource.postScopeText) }}
            </td>
          </tr>
          <tr v-if="application.type.id === APP_TYPE_POSITION_ATTESTATION" >
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('title') }}:</th>
            <td class="table-doc__cell">
               {{ application.resource.title }}
            </td>
          </tr>
          <tr v-else >
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('resourceName') }}:</th>
            <td class="table-doc__cell">
              <router-link v-if="application.type.id !== APP_TYPE_DEMO" :to="{name:'api.nrk.resource.get',params:{id:application.resource.id,type: (application.type.id === APP_TYPE_ATTESTATION || application.type.id === APP_TYPE_RRK) ? 'attestation':'nrk'} }"> {{ application.resource.title }}</router-link>
              <router-link v-else :to="{name:'api.nrk.resource.get',params:{id:application.resource.id,type: 'demo'} }"> {{ application.resource.title }}</router-link>
            </td>
          </tr>
          <tr v-if="application.resource.postType">
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('serviceType') }}:</th>
            <td class="table-doc__cell">
              {{ application.resource.postType.title }}
            </td>
          </tr>
          <tr v-if="application.resource.registerCategory">
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('positionCategory') }}:</th>
            <td class="table-doc__cell">
              {{ application.resource.registerCategory.title }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-md-12 mt-5">

      <section class="tabs">

        <ul class="nav  tabs__nav  tabs__hor-nav">
          <li v-if="application.hasMainTests || mainTests.length > 0" class="tabs__nav-item">
            <a class="tabs__nav-link" :class="{'active':tabs.mainTests}" data-toggle="tab" @click="tabSelect('mainTests','mainTests',false)" href="#tab-main">{{ getTranslation('mainNpaList') }}</a>
          </li>
          <li class="tabs__nav-item">
            <a class="tabs__nav-link" :class="{'active':tabs.tests}" data-toggle="tab" @click="tabSelect('tests','tests',false)" href="#tab-npa">{{ getTranslation('requiredNPA') }}</a>
          </li>
        </ul>

        <div class="tabs__content">

          <div id="tab-main" class="tabs__pane" :class="{'active':tabs.mainTests}">
            <div v-if="application.hasMainTests || mainTests.length > 0" class="col-md-12  col-xl-12">
              <div v-if="mainTests.length < 1" class="section__descr">{{ getTranslation('notAddedYet') }}</div>
              <NpaList v-if="active && mainTests.length > 0" :tests="mainTests"/>
            </div>
          </div>

          <div id="tab-npa" class="tabs__pane" :class="{'active':tabs.tests}">
            <div v-if="tests.length < 1 && application.testingStructure && application.testingStructure.hasLowType" class="section__descr text-danger">
              {{ getTranslation('warningRequiredNPA_notAdded') }}
            </div>
            <div v-else-if="tests.length < 1" class="section__descr">{{ getTranslation('notAddedYet') }}</div>
            <NpaList v-if="active && tests.length > 0" :tests="tests"/>
          </div>

        </div>

      </section>

    </div>
  </div>
</template>

<script>
import NpaList from "@/components/shared/NpaList";
import resourceTypeMixin from "@/views/admin/resources/mixins/resourceType";

export default {
  name: "AppPositionComponent",
  mixins: [resourceTypeMixin],
  components: {NpaList},
  props: {
    active: {
      type: Boolean,
      default: false
    },
    application: Object
  },
  data() {
    return {
      tests: [],
      mainTests: [],
      tabs: {
        tests: false,
        mainTests: false
      }
    }
  },
  watch: {
    'active'(val) {
      if (val) {

        this.fetchPositionData(this.application.id);

        this.tabSelect('tests', 'tests', false);

      }
    }
  },
  created() {
    if (this.active) {

      this.fetchPositionData(this.application.id);

      this.tabSelect('tests', 'tests', false);

    }

  },
  methods: {
    fetchPositionData(applicationId) {
      return this.axios.get(this.$config.urls.application.fetchPositionData.url.replace(':id', applicationId)).then(response => {

        this.tests = [];
        this.mainTests = [];

        this.tests = response.data.data.tests;
        this.mainTests = response.data.data.mainTests;

      }).catch(() => {
      });
    }
  }
}
</script>

<style scoped>

</style>
